<template>
  <div v-if="!this.loading">
    <h3 class="mt-5">{{this.datasetData.data.instance[0].showroom_name}} : Sample Data</h3>

    <div class="mt-5" v-for="tableDefinition in this.datasetData.data.tables" v-bind:key="tableDefinition.table_code">

      <h5> Table Name: <i> {{ tableDefinition.table_name }} </i> </h5>

        <table class="sample-table">
          <thead class="table-header">
            <tr>
              <th v-for="column in datasetData.data.content[tableDefinition.table_code]" v-bind:key="column.field_name">{{ column.field_name }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="tableRow in datasetData.data.samples[tableDefinition.table_code]" v-bind:key="tableDefinition.table_code + '_' +tableRow.row">
              <td v-for="column in datasetData.data.content[tableDefinition.table_code]" v-bind:key="column.field_name">{{ getColumnContent(tableRow, column.field_name ) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="footer mt-5">{{this.datasetData.data.instance[0].showroom_footer}}</p>

   </div>
</template>

<script>
import Data from '@/components/Data'
export default {
  name: 'SampleData',
  data () {
    return {
      dataset: this.$route.params.dataset,
      datasetData: {},
      loading: true,
      getColumnContent (row, columnName) {
        let value = ''
        try {
          let json = row.row_json
          let jsonObject = JSON.parse(json)
          value = jsonObject[columnName]
        } catch (e) {
          console.error('Error at showroom_index: ' + row.showroom_index + ', table_index: ' + row.table_index + ', row: ' + row.row)
          console.error('row_json: ' + row.row_json)
          console.error(e)
        }
        return value
      }
    }
  },
  mounted () {
    Data.get(this.dataset)
      .then(datasetData => {
        this.datasetData = datasetData
      }).catch(error => {
        console.error('error while calling dataset data:' + this.dataset)
        console.error(error)
        return this.$router.push('/404')
      }).finally(() => {
        this.loading = false
      })
  }
}
</script>

<style scoped>
.table-header, .footer{
  background-color: #F4EFEA;
}

table.sample-table {
  max-height: 900px;
}

@media (max-width: 1930px) {
  table.sample-table {
    max-height: 500px;
  }
}

table.sample-table{
  overflow: auto;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/SampleData.vue